/**
 * Colors for the 5-point survey scale, worst to best.
 * One definition shared by the bar and the legend so the two can never disagree.
 * Tangerine for disagreement, a warm neutral, and Medley greens for agreement.
 */
export const SCALE_COLORS = ['#F09A65', '#F6C4A4', '#DAD6CE', '#6E8A7E', '#28463A'];

/**
 * Segments on these colors need dark text: white fails AA at 11px on every
 * color except the darkest green (black is 8.56:1 on tangerine, 5.04:1 on agree).
 */
export const LIGHT_SCALE_INDEXES = new Set([0, 1, 2, 3]);

/** Fallback colors for non-scale questions with more than 5 options */
export const EXTENDED_COLORS = [
  '#C05621', '#DD6B20', '#ECC94B', '#A0AEC0', '#68D391',
  '#2F855A', '#3182CE', '#805AD5', '#D53F8C', '#718096',
];
